import React from 'react';
import config from '../config.json';

const MonsterLineup = ({ gym, monsters }) => {
  const totalSlots = 6;
  const lineup = Array(totalSlots).fill(null);
  let highestLineupPosition = 6 - gym.slots_available;
  
  // Place monsters in the correct positions in the lineup
  monsters.forEach(monster => {
    if (monster.lineup_position >= 1 && monster.lineup_position <= totalSlots) {
      lineup[monster.lineup_position - 1] = monster;
      highestLineupPosition = Math.max(highestLineupPosition, monster.lineup_position);
    }
  });
  
  return (
    <div className="monster-lineup">
      {gym.team === 0 ? (
        <div className="empty-gym-message">
          <p>This gym is currently empty.</p>
        </div>
      ) : (
        <>
          <div className="monster-slots">
            {lineup.map((monster, index) => (
              <div key={monster ? `${monster.gym_id}_${monster.lineup_position}` : `empty_${index}`} className={`monster-slot ${monster ? '' : 'empty'}`}>
                {monster ? (
                  <>
                    <div className="monster-name">#{String(monster.monster_id)}</div>
                    <div className="monster-image">
                      <img
                        src={`${config.monster_image_repo}${String(monster.monster_id)}.png`}
                        alt={`#${monster.monster_id}`}
                        onError={(e) => {
                          e.target.src = `${config.monster_image_repo}0.png`;
                        }}
                      />
                    </div>
                    <div className="monster-cp">
                      {monster.cp === -1 ? 'CP ???' : `CP ${monster.cp}`}
                    </div>
                  </>
                ) : (
                  <div className="empty-slot-icon">{index < highestLineupPosition ? '???' : '-'}</div>
                )}
              </div>
            ))}
          </div>
          
          {monsters.length === 0 && gym.team !== 0 && (
            <div className="empty-lineup-message">
              <p>No monsters in this gym yet.</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MonsterLineup;
